export default __webpack_public_path__ + "static/media/applepaywhite.c343607e.svg";